import { graphql } from '~/gql'

import { useDownloadFile } from './useDownloadFile'

const document = graphql(`
  query DataSettingsPage_GenerateQuestionnaireDownloadURL($surveyId: String!) {
    generateDownloadURL: generateQuestionnaireDownloadURL(surveyId: $surveyId) {
      url
    }
  }
`)

export const useDownloadQuestionFile = () => useDownloadFile(document)
